import { render, staticRenderFns } from "./StoresStoreInformation.vue?vue&type=template&id=585aa45e&scoped=true&"
import script from "./StoresStoreInformation.vue?vue&type=script&lang=js&"
export * from "./StoresStoreInformation.vue?vue&type=script&lang=js&"
import style0 from "./StoresStoreInformation.vue?vue&type=style&index=0&id=585aa45e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585aa45e",
  null
  
)

export default component.exports